import Store from 'Services/Store';
import Feature from 'Services/Feature';
import AutomationTemplatesSellsy from 'vcomponents/automation/templates/AutomationTemplatesSellsy.vue';
import AutomationListing from 'vcomponents/automation/listing/AutomationListing.vue';
import AutomationBuilder from 'vcomponents/automation/builder/AutomationBuilder.vue';

const isStaff = (user) => {
    return user.type === 'staff';
};

const hasFullAccess = (user) => {
    return user.isAdmin || user.permissions?.acl?.manage_automations;
};

const checkAccess = (to, from, next) => {
    const user = Store.get('user');
    const isAuthorized = isStaff(user) && Feature.isEnabled('automations') && hasFullAccess(user);
    if (isAuthorized) {
        next();
    } else {
        next({ name: 'error.not.found' });
    }
};

const checkAccessTemplates = (to, from, next) => {
    const user = Store.get('user');
    if (isStaff(user) && Feature.isEnabled('automations')) {
        next();
    } else {
        next({ name: 'error.not.found' });
    }
};

export default [
    {
        path: '/automations',
        redirect: () => {
            const user = Store.get('user');
            if (!isStaff(user)) {
                return { name: 'error.not.found' };
            }
            return hasFullAccess(user) ? '/automations/listing' : '/automations/templates';
        },
    },
    {
        path: '/automations/listing',
        name: 'automations.listing',
        component: AutomationListing,
        beforeEnter: checkAccess,
    },
    {
        path: '/automations/templates',
        name: 'automations.templates',
        component: AutomationTemplatesSellsy,
        beforeEnter: checkAccessTemplates,
    },
    {
        path: '/automations/templates/:internalId',
        name: 'automations.templates.share',
        component: AutomationTemplatesSellsy,
        beforeEnter: checkAccessTemplates,
    },
    {
        path: '/automations/builder/:id',
        name: 'automations.flow.builder',
        component: AutomationBuilder,
        beforeEnter: checkAccess,
    },
];
